import { DwIcon } from "@dreamworld/dw-icon/dw-icon";

/**
 * Extended version of [dw-icon](https://github.com/DreamworldSolutions/dw-icon).
 */
export class KerikaIcon extends DwIcon {}

customElements.define("kerika-icon", KerikaIcon);
